module.exports = __webpack_public_path__ + "static/media/tap-04.f8f3cdda.png";